var React = require('react');

function CircleIconPlayInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(2 2)","fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"className":"circle","strokeWidth":"2","width":"65","height":"65","rx":"32.5","key":0}),React.createElement("path",{"className":"icon","strokeWidth":"0","d":"M41.292 31.445c.943.583.945 1.527 0 2.11l-13.584 8.39c-.943.583-1.708.153-1.708-.94v-17.01c0-1.102.763-1.523 1.708-.94l13.584 8.39z","key":1})]));
}

CircleIconPlayInline.defaultProps = {"viewBox":"0 0 68 68"};

module.exports = CircleIconPlayInline;

CircleIconPlayInline.default = CircleIconPlayInline;
